import { post } from '..';
import routes from './routes';

const AuthServices = {
  login: async (obj) => {
    const data = await post(routes.login, obj);
    return data;
  },
  logout: async (obj) => {
    const data = await post(routes.logout, obj);
    return data;
  },
}

export default AuthServices